import { Typography, makeStyles, Box } from '@material-ui/core'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'

import { SpacedGroup } from 'UI/Components/index'
import { PlaybookType } from 'app/types'

const useStyles = makeStyles(theme => ({
    trackLinkHeader: {
        padding: theme.spacing(2),
        background: 'white'
    },
    shareText: {
        fontSize: '12px',
        fontWeight: 'bold',
        paddingBottom: theme.spacing()
    },
    spacesAndUsersAmount: { fontSize: '12px' }
}))

type Props = {
    playbook: PlaybookType
}

export const TrackLinkHeader = ({ playbook }: Props) => {
    const classes = useStyles()

    const { teams = [], publishedForUsers = [], isPlaylist } = playbook

    return (
        <SpacedGroup
            spacing={2}
            justifyContent="flex-start"
            alignItems="center"
            className={classes.trackLinkHeader}
        >
            <NavigateNextIcon />
            <Box>
                <Typography className={classes.shareText}>
                    Share {isPlaylist ? 'Playlist' : 'Video'}
                </Typography>
                <Typography className={classes.spacesAndUsersAmount}>
                    Shared with:{' '}
                    {Boolean(teams?.length)
                        ? teams?.map(space => space.name).join(', ')
                        : '0 Spaces'}
                    ,{' '}
                    {publishedForUsers?.length <= 1
                        ? `${publishedForUsers?.length} Member`
                        : `${publishedForUsers?.length || 0} Members`}
                </Typography>
            </Box>
        </SpacedGroup>
    )
}
